import { FILE_VALIDATORS } from '@/configs/validator';

type ValidatorKey = keyof typeof FILE_VALIDATORS;

export const MIN_LENGTH_PASSWORD = 8;

const MAX_FILE_SIZE = 1048576;

export const validateFileSize = (
    name: ValidatorKey,
    fileList?: FileList | null,
): boolean => {
    if (!fileList?.length) {
        return true;
    }

    for (let index = 0; index < fileList.length; index++) {
        if (
            Number(fileList.item(index)?.size) >
            Number(FILE_VALIDATORS[name]?.maxSize) * MAX_FILE_SIZE
        ) {
            return false;
        }
    }

    return true;
};

export const validateFileType = (
    name: ValidatorKey,
    fileList?: FileList | null,
): boolean => {
    if (!fileList?.length) {
        return true;
    }

    for (let index = 0; index < fileList.length; index++) {
        const itemType = fileList.item(index)?.type;

        if (!itemType || !FILE_VALIDATORS[name].accept.includes(itemType)) {
            return false;
        }
    }

    return true;
};

export const getDisplayMimeTypes = (mimeTypes: string[]): string[] =>
    mimeTypes.map((type) => type.split('/')[1]);
